/* DM hero — "slider"-variant: productwaaier met roterende kaarten,
   pijlknoppen, dots, autoplay (pauze bij hover/focus, respecteert
   prefers-reduced-motion) en swipe op touch. */
class DmHeroSlider extends HTMLElement {
  connectedCallback() {
    this.cards = Array.from(this.querySelectorAll('[data-dm-fan-card]'));
    this.texts = Array.from(this.querySelectorAll('[data-dm-slide-text]'));
    this.dots = Array.from(this.querySelectorAll('[data-dm-dot]'));
    this.fan = this.querySelector('[data-dm-fan]');
    if (!this.cards.length) return;

    this.index = 0;
    this.autoplayInterval = parseInt(this.dataset.autoplayInterval, 10) || 4000;
    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    this.desktopQuery = window.matchMedia('(min-width: 750px)');

    this.querySelector('[data-dm-prev]')?.addEventListener('click', () => this.goTo(this.index - 1, true));
    this.querySelector('[data-dm-next]')?.addEventListener('click', () => this.goTo(this.index + 1, true));
    this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.goTo(i, true)));

    if (this.fan) {
      this.fan.addEventListener('touchstart', (event) => this.onTouchStart(event), { passive: true });
      this.fan.addEventListener('touchend', (event) => this.onTouchEnd(event), { passive: true });
    }

    this.addEventListener('mouseenter', () => this.pause());
    this.addEventListener('mouseleave', () => this.play());
    this.addEventListener('focusin', () => this.pause());
    this.addEventListener('focusout', (event) => {
      if (!this.contains(event.relatedTarget)) this.play();
    });
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) this.pause();
      else this.play();
    });

    this.desktopQuery.addEventListener?.('change', () => this.update());
    this.reducedMotion.addEventListener?.('change', () => {
      this.pause();
      this.play();
    });

    this.update();
    this.play();
  }

  disconnectedCallback() {
    this.pause();
  }

  play() {
    if (this.reducedMotion.matches || this.cards.length < 2) return;
    this.pause();
    this.timer = setInterval(() => this.goTo(this.index + 1, false), this.autoplayInterval);
  }

  pause() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }

  goTo(index, userInitiated) {
    const count = this.cards.length;
    this.index = ((index % count) + count) % count;
    this.update();
    if (userInitiated) {
      this.pause();
      this.play();
    }
  }

  onTouchStart(event) {
    this.touchStartX = event.touches?.[0]?.clientX ?? null;
  }

  onTouchEnd(event) {
    if (this.touchStartX == null || !event.changedTouches?.[0]) return;
    const deltaX = event.changedTouches[0].clientX - this.touchStartX;
    this.touchStartX = null;
    if (deltaX > 40) this.goTo(this.index - 1, true);
    else if (deltaX < -40) this.goTo(this.index + 1, true);
  }

  update() {
    const count = this.cards.length;
    const desktop = this.desktopQuery.matches;
    const step = desktop ? 128 : 84;
    const drop = desktop ? 9 : 7;

    this.cards.forEach((card, i) => {
      let d = i - this.index;
      if (d > count / 2) d -= count;
      if (d < -count / 2) d += count;
      const ad = Math.abs(d);
      const opacity = ad <= 1 ? 1 : ad === 2 ? 0.4 : ad === 3 ? 0.12 : 0;

      card.style.transform = `translateX(calc(-50% + ${d * step}px)) translateY(${ad * ad * drop}px) rotate(${
        d * 8
      }deg) scale(${1 - ad * 0.07})`;
      card.style.opacity = opacity;
      card.style.zIndex = String(10 - ad);
      card.style.pointerEvents = ad <= 1 ? 'auto' : 'none';
      card.tabIndex = ad === 0 ? 0 : -1;
      card.setAttribute('aria-hidden', ad === 0 ? 'false' : 'true');
      card.classList.toggle('is-active', ad === 0);
    });

    this.texts.forEach((text, i) => {
      text.classList.toggle('is-active', i === this.index);
      text.toggleAttribute('hidden', i !== this.index);
    });

    this.dots.forEach((dot, i) => {
      dot.classList.toggle('is-active', i === this.index);
      dot.setAttribute('aria-current', i === this.index ? 'true' : 'false');
    });
  }
}

if (!customElements.get('dm-hero-slider')) customElements.define('dm-hero-slider', DmHeroSlider);
